<div class="d-flex flex-column spacing-8">
  <div class="d-flex flex-column">
    @if (headingTitle) {
      <h3 class="h3-bold primary-100">{{ headingTitle }}</h3>
    }
    @if (subtitle) {
      <h4 class="h4-reg primary-60">{{ subtitle }}</h4>
    }
  </div>
  <div
    [style.height]="height ? height + 'px' : '350px'"
    [style.width]="width ? width + 'px' : 'auto'"
    [class.tab-height]="chartType === 'bar'">
    @if (!errorState()) {
      @if (chartType === 'bar') {
        <app-custom-bar-chart
          [title]="title"
          [ValueTooltip]="ValueTooltip"
          [multipleTitlesInput]="multipleTitles"
          [statsMap]="statsMap"
          [pagination]="paginationData"
          [showPagination]="showPagination"
          [badgeType]="badgeType"
          [tabs]="tabs"
          [defaultActiveTab]="defaultActiveTab || (tabs && tabs.length > 0 ? tabs[0].id : 'state')"
          (tabChange)="onTabChange($any($event))"
          (pageChange)="onPageChange($any($event))"></app-custom-bar-chart>
      } @else {
        <div class="empty-state-message">No data available for this chart type.</div>
      }
    }

    @if (errorState()) {
      <app-error-state
        [errorMessage]="{ title: 'Error', message: errorState()! }"></app-error-state>
    }
  </div>
</div>
